import * as types from "./DemandTableActionType";

// Fetch Volume Trend Reports Dropdown
export const fetchVolumeTrendReportsDDRequest = () => ({
  type: types.FETCH_VOLUME_TREND_REPORTS_DD_REQUEST,
});
export const fetchVolumeTrendReportsDDSuccess = (payload) => ({
  type: types.FETCH_VOLUME_TREND_REPORTS_DD_SUCCESS,
  payload,
});
export const fetchVolumeTrendReportsDDFailure = (error) => ({
  type: types.FETCH_VOLUME_TREND_REPORTS_DD_FAILURE,
  error,
});

// Fetch Reports Tab Data with Pagination
export const fetchReportsTabRequest = (payload) => ({
  type: types.FETCH_REPORTS_TAB_REQUEST,
  payload,
});
export const fetchReportsTabSuccess = (payload) => ({
  type: types.FETCH_REPORTS_TAB_SUCCESS,
  payload,
});
export const fetchReportsTabFailure = (error) => ({
  type: types.FETCH_REPORTS_TAB_FAILURE,
  error,
});

// Fetch Onboarding Tab Data
export const fetchOnboardingTabRequest = (payload) => ({
  type: types.FETCH_ONBOARDING_TAB_REQUEST,
  payload,
});
export const fetchOnboardingTabSuccess = (payload) => ({
  type: types.FETCH_ONBOARDING_TAB_SUCCESS,
  payload,
});
export const fetchOnboardingTabFailure = (error) => ({
  type: types.FETCH_ONBOARDING_TAB_FAILURE,
  error,
});

// Notes Edit Actions
export const fetchNotesEditRequest = (payload) => ({
  type: types.FETCH_NOTES_EDIT_REQUEST,
  payload,
});
export const fetchNotesEditSuccess = (payload) => ({
  type: types.FETCH_NOTES_EDIT_SUCCESS,
  payload,
});
export const fetchNotesEditFailure = (error) => ({
  type: types.FETCH_NOTES_EDIT_FAILURE,
  error,
});

//Notes Save Actions
export const fetchNotesSaveRequest = (payload) => ({
  type: types.FETCH_NOTES_SAVE_REQUEST,
  payload,
});
export const fetchNotesSaveSuccess = (payload) => ({
  type: types.FETCH_NOTES_SAVE_SUCCESS,
  payload,
});
export const fetchNotesSaveFailure = (error) => ({
  type: types.FETCH_NOTES_SAVE_FAILURE,
  error,
});

//Export Reports Tab Actions
export const exportReportsRequest = (payload) => ({
  type: types.EXPORT_REPORTS_REQUEST,
  payload,
});
export const exportReportsSuccess = (payload) => ({
  type: types.EXPORT_REPORTS_SUCCESS,
  payload,
});
export const exportReportsFailure = (error) => ({
  type: types.EXPORT_REPORTS_FAILURE,
  error,
});

export const fetchDemandTableByReportRequest = (payload) => ({
  type: types.FETCH_DEMAND_TABLE_BY_REPORT_REQUEST,
  payload,
});
export const fetchDemandTableByReportSuccess = (payload) => ({
  type: types.FETCH_DEMAND_TABLE_BY_REPORT_SUCCESS,
  payload,
});
export const fetchDemandTableByReportFailure = (error) => ({
  type: types.FETCH_DEMAND_TABLE_BY_REPORT_FAILURE,
  error,
});

// Fetch Get Demand Input Filter Dropdown List
export const fetchGetDemandInputFilterDDListSuccess = (payload) => ({
  type: types.FETCH_GET_DEMAND_INPUT_FILTER_DD_LIST_SUCCESS,
  payload,
});
export const fetchGetDemandInputFilterDDListFailure = (error) => ({
  type: types.FETCH_GET_DEMAND_INPUT_FILTER_DD_LIST_FAILURE,
  error,
});

// Fetch Worklist By Site Dropdown List
export const fetchWorklistBySiteDDListRequest = (payload) => ({
  type: types.FETCH_WORKLIST_BY_SITE_DD_LIST_REQUEST,
  payload,
});
export const fetchWorklistBySiteDDListSuccess = (payload) => ({
  type: types.FETCH_WORKLIST_BY_SITE_DD_LIST_SUCCESS,
  payload,
});
export const fetchWorklistBySiteDDListFailure = (error) => ({
  type: types.FETCH_WORKLIST_BY_SITE_DD_LIST_FAILURE,
  error,
});

// Fetch Worklist With Site Mapping Dropdown List
export const fetchWorklistWithSiteMappingDDListRequest = () => ({
  type: types.FETCH_WORKLIST_WITH_SITE_MAPPING_DD_LIST_REQUEST,
});
export const fetchWorklistWithSiteMappingDDListSuccess = (payload) => ({
  type: types.FETCH_WORKLIST_WITH_SITE_MAPPING_DD_LIST_SUCCESS,
  payload,
});
export const fetchWorklistWithSiteMappingDDListFailure = (error) => ({
  type: types.FETCH_WORKLIST_WITH_SITE_MAPPING_DD_LIST_FAILURE,
  error,
});

export const fetchWorklistByWorklistGroupDDListRequest = (payload) => ({
  type: types.FETCH_WORKLIST_BY_WORKLISTGROUP_DD_LIST_REQUEST,
  payload,
});
export const fetchWorklistByWorklistGroupDDListSuccess = (payload) => ({
  type: types.FETCH_WORKLIST_BY_WORKLISTGROUP_DD_LIST_SUCCESS,
  payload,
});
export const fetchWorklistByWorklistGroupDDListFailure = (error) => ({
  type: types.FETCH_WORKLIST_BY_WORKLISTGROUP_DD_LIST_FAILURE,
  error,
});

// Delete Demand Report
export const deleteDemandReportSuccess = (payload) => ({
  type: types.DELETE_DEMAND_REPORT_SUCCESS,
  payload,
});
export const deleteDemandReportFailure = (error) => ({
  type: types.DELETE_DEMAND_REPORT_FAILURE,
  error,
});

// Demand Table (6th Tab) - Fetch paginated demand data
export const fetchDemandTableTabRequest = (payload) => ({
  type: types.FETCH_DEMAND_TABLE_TAB_REQUEST,
  payload,
});
export const fetchDemandTableTabSuccess = (payload) => ({
  type: types.FETCH_DEMAND_TABLE_TAB_SUCCESS,
  payload,
});
export const fetchDemandTableTabFailure = (error) => ({
  type: types.FETCH_DEMAND_TABLE_TAB_FAILURE,
  error,
});

// Fetch All Tabs Demand Table Data by Id (tab binding)
export const fetchDemandTableByIdRequest = (payload) => ({
  type: types.FETCH_DEMAND_TABLE_BY_ID_REQUEST,
  payload,
});
export const fetchDemandTableByIdSuccess = (payload) => ({
  type: types.FETCH_DEMAND_TABLE_BY_ID_SUCCESS,
  payload,
});
export const fetchDemandTableByIdFailure = (error) => ({
  type: types.FETCH_DEMAND_TABLE_BY_ID_FAILURE,
  error,
});

// Export Onboarding Table Data
export const exportOnboardingRequest = (payload) => ({
  type: types.EXPORT_ONBOARDING_REQUEST,
  payload,
});
export const exportOnboardingSuccess = (payload) => ({
  type: types.EXPORT_ONBOARDING_SUCCESS,
  payload,
});
export const exportOnboardingFailure = (error) => ({
  type: types.EXPORT_ONBOARDING_FAILURE,
  error,
});

// Bulk Update Practice Data
export const bulkUpdatePracticeRequest = (payload, meta) => ({
  type: types.BULK_UPDATE_PRACTICE_REQUEST,
  payload,
  meta, // for onSuccess callback
});
export const bulkUpdatePracticeSuccess = (payload) => ({
  type: types.BULK_UPDATE_PRACTICE_SUCCESS,
  payload,
});
export const bulkUpdatePracticeFailure = (error) => ({
  type: types.BULK_UPDATE_PRACTICE_FAILURE,
  error,
});

// Bulk Update Site Data
export const bulkUpdateSiteRequest = (payload, meta) => ({
  type: types.BULK_UPDATE_SITE_REQUEST,
  payload,
  meta,
});
export const bulkUpdateSiteSuccess = (payload) => ({
  type: types.BULK_UPDATE_SITE_SUCCESS,
  payload,
});
export const bulkUpdateSiteFailure = (error) => ({
  type: types.BULK_UPDATE_SITE_FAILURE,
  error,
});

// Bulk Delete Practice Data
export const bulkDeletePracticeRequest = (payload, meta) => ({
  type: types.BULK_DELETE_PRACTICE_REQUEST,
  payload,
  meta,
});
export const bulkDeletePracticeSuccess = (payload) => ({
  type: types.BULK_DELETE_PRACTICE_SUCCESS,
  payload,
});
export const bulkDeletePracticeFailure = (error) => ({
  type: types.BULK_DELETE_PRACTICE_FAILURE,
  error,
});

// Bulk Delete Site Data
export const bulkDeleteSiteRequest = (payload, meta) => ({
  type: types.BULK_DELETE_SITE_REQUEST,
  payload,
  meta,
});
export const bulkDeleteSiteSuccess = (payload) => ({
  type: types.BULK_DELETE_SITE_SUCCESS,
  payload,
});
export const bulkDeleteSiteFailure = (error) => ({
  type: types.BULK_DELETE_SITE_FAILURE,
  error,
});

// Export Practice Table Data
export const exportPracticeRequest = (payload) => ({
  type: types.EXPORT_PRACTICE_REQUEST,
  payload,
});
export const exportPracticeSuccess = (payload) => ({
  type: types.EXPORT_PRACTICE_SUCCESS,
  payload,
});
export const exportPracticeFailure = (error) => ({
  type: types.EXPORT_PRACTICE_FAILURE,
  error,
});

// Export Site Table Data
export const exportSiteRequest = (payload) => ({
  type: types.EXPORT_SITE_REQUEST,
  payload,
});
export const exportSiteSuccess = (payload) => ({
  type: types.EXPORT_SITE_SUCCESS,
  payload,
});
export const exportSiteFailure = (error) => ({
  type: types.EXPORT_SITE_FAILURE,
  error,
});

export const exportWorklistRequest = (payload) => ({
  type: types.EXPORT_WORKLIST_REQUEST,
  payload,
});
export const exportWorklistSuccess = (payload) => ({
  type: types.EXPORT_WORKLIST_SUCCESS,
  payload,
});
export const exportWorklistFailure = (error) => ({
  type: types.EXPORT_WORKLIST_FAILURE,
  error,
});

// Refresh Demand Table Data
export const refreshDemandTableRequest = (payload) => ({
  type: types.REFRESH_DEMAND_TABLE_REQUEST,
  payload,
});
export const refreshDemandTableSuccess = (payload) => ({
  type: types.REFRESH_DEMAND_TABLE_SUCCESS,
  payload,
});
export const refreshDemandTableFailure = (error) => ({
  type: types.REFRESH_DEMAND_TABLE_FAILURE,
  error,
});

// Save As Draft Actions
export const saveAsDraftRequest = (payload, callbacks = {}) => ({
  type: types.SAVE_AS_DRAFT_REQUEST,
  payload,
  callbacks,
});
export const saveAsDraftSuccess = (data) => ({
  type: types.SAVE_AS_DRAFT_SUCCESS,
  payload: data,
});
export const saveAsDraftFailure = (error) => ({
  type: types.SAVE_AS_DRAFT_FAILURE,
  payload: error,
});

// Publish Demand Table Report Actions
export const publishDemandTableRequest = (payload, callbacks = {}) => ({
  type: types.PUBLISH_DEMAND_TABLE_REQUEST,
  payload,
  callbacks,
});
export const publishDemandTableSuccess = (data) => ({
  type: types.PUBLISH_DEMAND_TABLE_SUCCESS,
  payload: data,
});
export const publishDemandTableFailure = (error) => ({
  type: types.PUBLISH_DEMAND_TABLE_FAILURE,
  payload: error,
});

// View Demand Table Actions
export const viewDemandTableRequest = (payload) => ({
  type: types.VIEW_DEMAND_TABLE_REQUEST,
  payload,
});
export const viewDemandTableSuccess = (payload) => ({
  type: types.VIEW_DEMAND_TABLE_SUCCESS,
  payload,
});
export const viewDemandTableFailure = (error) => ({
  type: types.VIEW_DEMAND_TABLE_FAILURE,
  error,
});

// Fetch Demand Changes Practice Data
export const fetchDemandChangesPracticeRequest = (payload) => ({
  type: types.FETCH_DEMAND_CHANGES_PRACTICE_REQUEST,
  payload,
});
export const fetchDemandChangesPracticeSuccess = (payload) => ({
  type: types.FETCH_DEMAND_CHANGES_PRACTICE_SUCCESS,
  payload,
});
export const fetchDemandChangesPracticeFailure = (error) => ({
  type: types.FETCH_DEMAND_CHANGES_PRACTICE_FAILURE,
  error,
});

// Fetch Demand Changes Site Data
export const fetchDemandChangesSiteRequest = (payload) => ({
  type: types.FETCH_DEMAND_CHANGES_SITE_REQUEST,
  payload,
});
export const fetchDemandChangesSiteSuccess = (payload) => ({
  type: types.FETCH_DEMAND_CHANGES_SITE_SUCCESS,
  payload,
});
export const fetchDemandChangesSiteFailure = (error) => ({
  type: types.FETCH_DEMAND_CHANGES_SITE_FAILURE,
  error,
});

// Fetch/Apply Demand Changes Worklist Data
export const fetchDemandChangesWorklistRequest = (payload) => ({
  type: types.FETCH_DEMAND_CHANGES_WORKLIST_REQUEST,
  payload,
});
export const fetchDemandChangesWorklistSuccess = (payload) => ({
  type: types.FETCH_DEMAND_CHANGES_WORKLIST_SUCCESS,
  payload,
});
export const fetchDemandChangesWorklistFailure = (error) => ({
  type: types.FETCH_DEMAND_CHANGES_WORKLIST_FAILURE,
  error,
});

// Bulk Update Worklist Data
export const bulkUpdateWorklistRequest = (payload, meta) => ({
  type: types.BULK_UPDATE_WORKLIST_REQUEST,
  payload,
  meta,
});
export const bulkUpdateWorklistSuccess = (payload) => ({
  type: types.BULK_UPDATE_WORKLIST_SUCCESS,
  payload,
});
export const bulkUpdateWorklistFailure = (error) => ({
  type: types.BULK_UPDATE_WORKLIST_FAILURE,
  error,
});

// Bulk Delete Worklist Data
export const bulkDeleteWorklistRequest = (payload, meta) => ({
  type: types.BULK_DELETE_WORKLIST_REQUEST,
  payload,
  meta,
});
export const bulkDeleteWorklistSuccess = (payload) => ({
  type: types.BULK_DELETE_WORKLIST_SUCCESS,
  payload,
});
export const bulkDeleteWorklistFailure = (error) => ({
  type: types.BULK_DELETE_WORKLIST_FAILURE,
  error,
});

// Fetch Holiday Coverage Worklist Data
export const fetchHolidayCoverageWorklistRequest = (payload) => ({
  type: types.FETCH_HOLIDAY_COVERAGE_WORKLIST_REQUEST,
  payload,
});
export const fetchHolidayCoverageWorklistSuccess = (payload) => ({
  type: types.FETCH_HOLIDAY_COVERAGE_WORKLIST_SUCCESS,
  payload,
});
export const fetchHolidayCoverageWorklistFailure = (error) => ({
  type: types.FETCH_HOLIDAY_COVERAGE_WORKLIST_FAILURE,
  error,
});

// Update Demand Table Reducer
export const updateDemandTableReducer = (payload) => ({
  type: types.UPDATE_DEMAND_TABLE_REDUCER,
  payload,
});

export const resetDemandTableState = () => ({
  type: types.RESET_DEMAND_TABLE_STATE,
});
